import { render } from "./EditP1PROCModal.vue?vue&type=template&id=89d22e70&scoped=true"
import script from "./EditP1PROCModal.vue?vue&type=script&lang=js"
export * from "./EditP1PROCModal.vue?vue&type=script&lang=js"

import "./EditP1PROCModal.vue?vue&type=style&index=0&id=89d22e70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89d22e70"]])

export default __exports__